import { render, staticRenderFns } from "./OsEntityToolbar.vue?vue&type=template&id=6882c16a&scoped=true"
import script from "./OsEntityToolbar.vue?vue&type=script&lang=ts"
export * from "./OsEntityToolbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6882c16a",
  null
  
)

export default component.exports